(() => {
  const productPage = document.body.classList.contains('template-product');
  const mobile = matchMedia('(max-width:749px), (hover:none), (pointer:coarse)');
  const cardCleanup = new WeakMap();
  const init = root => {
    root.querySelectorAll('.paw-details .paw-detail-grid').forEach(grid => {
      if (grid.dataset.interactionReady) return;
      grid.dataset.interactionReady = 'true';
      const cards = [...grid.querySelectorAll('.paw-detail-card')];
      const events = new AbortController();
      let frame, visible = false;
      const highlight = () => {
        frame = undefined;
        let nearest, distance = Infinity;
        if (mobile.matches && visible) cards.forEach(card => {
          const rect = card.getBoundingClientRect();
          if (rect.bottom <= 0 || rect.top >= innerHeight) return;
          const delta = Math.abs(rect.top + rect.height / 2 - innerHeight / 2);
          if (delta < distance) { nearest = card; distance = delta; }
        });
        cards.forEach(card => card.classList.toggle('is-in-focus', card === nearest));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(highlight); };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        schedule();
      }) : null;
      if (observer) observer.observe(grid);
      else visible = true;
      window.addEventListener('scroll', () => { if (visible) schedule(); }, { passive: true, signal: events.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: events.signal });
      mobile.addEventListener('change', schedule, { signal: events.signal });
      cardCleanup.set(grid, () => {
        events.abort();
        observer?.disconnect();
        if (frame) cancelAnimationFrame(frame);
        cards.forEach(card => card.classList.remove('is-in-focus'));
        delete grid.dataset.interactionReady;
        cardCleanup.delete(grid);
      });
      highlight();
    });
    if (!productPage) return;
    const beats = [...root.querySelectorAll('.paw-story-beat')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-in-view', entry.isIntersecting)));
      beats.forEach(beat => observer.observe(beat));
      const videos = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }));
      root.querySelectorAll('.paw-content video').forEach(video => videos.observe(video));
    } else beats.forEach(beat => beat.classList.add('is-in-view'));
  };
  if (productPage) {
    document.addEventListener('play', event => {
      if (!event.target.matches?.('.paw-content video')) return;
      document.querySelectorAll('.paw-content video').forEach(video => { if (video !== event.target) video.pause(); });
    }, true);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) document.querySelectorAll('.paw-content video').forEach(video => video.pause());
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.paw-details .paw-detail-grid').forEach(grid => cardCleanup.get(grid)?.());
  });
})();
